<template>
  <div>
    <Breadcrumbs page_title="course" :items="breadcrumbs" />

    <v-container fluid>
      <v-row v-if="loading" class="mt-5">
        <v-col cols="2" v-for="n in 4" :key="n">
          <v-skeleton-loader class="mx-auto" max-height="180" type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
      <v-row v-else class="mt-5">
        <v-col cols="12" xs="12" sm="12" md="4" lg="2" v-for="(item, i) in cardItems" :key="i">
          <v-card style="border-radius: 16px" :style="[
            item.selected == true
              ? { border: '2px solid ' + item.bgcolor }
              : {},
          ]" height="220" @click="selectCourseCategory(item)">
            <v-card-text justify="center" align="center" style="height: 100%">
              <div class="imgBg" :style="[
                item.bgcolor
                  ? { 'background-color': item.bgcolor }
                  : { 'background-color': '#a6cc39' },
              ]"></div>

              <v-img :src="item.image" width="52" class="courseImg"></v-img>

              <p class="text-center mt-5" style="font-size: 20px; color: #424242">
                {{ $t(item.title) }}
              </p>
              <p v-if="item.courseCount > 1" class="coursecounttext" :style="{
                color: item.title === 'complete' ? '#4FB050' : '#8A0000',
                fontSize: '16px',
              }">
                {{ item.courseCount }} {{ $t("coursess") }}
              </p>
              <p v-else-if="item.courseCount === 1" class="coursecounttext" :style="{
                color: item.title === 'complete' ? '#4FB050' : '#8A0000',
                fontSize: '16px',
              }">
                {{ item.courseCount }} {{ $t("courses") }}
              </p>
              <p v-else class="coursecounttext" :style="{
                color: item.title === 'complete' ? '#4FB050' : '#8A0000',
                fontSize: '16px',
              }">
                0 {{ $t("course") }}
              </p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="showCourseList">
        <v-col cols="12" md="10" lg="8">
          <v-card style="
              width: 1314px;
              background: #ffffff 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 6px #0000000f;
              border-radius: 16px;
            ">
            <div class="mt-p pt-3">
              <v-text-field outlined dense hide-details clearable :placeholder="$t('search') + '...'" v-model="search"
                class="custom-padding mb-4 ml-3 mr-3">
              </v-text-field>
            </div>
            <div class="pb-4 ml-4 mr-4">
              <v-list>
                <v-list-group active-class="primary--text" style="margin-bottom: 0.7rem" class="list-Bg"
                  v-for="item in searchInLists" :key="item.assignmentCourseID"
                  @click="getCourseDetailFiles(item.assignmentCourseID)" append-icon no-action>
                  <template v-slot:activator>
                    <v-row no-gutters class="course-header-row">
                      <v-col cols="8" md="8" lg="8" xl="9" class="d-flex align-center px-0" style="
                          gap: 1rem;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          white-space: nowrap;
                        ">
                        <v-img :src="item.coursePicture
                          ? item.coursePicture
                          : require('@/assets/coursedefaultimage.png')
                          " alt="Logo" contain class="course-image"></v-img>

                        <!-- F05 DSD: ปุ่มรายละเอียดหลักสูตร (UX8/UX9) -->
                        <v-btn icon color="#424242" class="course-info-btn" data-testid="btn-course-info"
                          :aria-label="$t('coursedetails')" @click.stop="openCourseInfo(item.assignmentCourseID)"
                          @keydown.enter.stop @mousedown.stop>
                          <v-icon>mdi-information-outline</v-icon>
                        </v-btn>

                        <div style="
                            min-height: 79px;
                            row-gap: 1.5rem;
                            max-width: 750px;
                          " class="d-flex flex-column mt-1" :style="$vuetify.breakpoint.mdAndUp &&
                            $vuetify.breakpoint.lgAndDown
                            ? 'width: 300px'
                            : $vuetify.breakpoint.smAndDown
                              ? 'width: 240px'
                              : 'auto'
                            ">

                          <p style="
                              color: #424242;
                              font-size: 17px;
                              margin-bottom: 0;
                            " class="textWrappingStyle">
                            {{ item.courseName }}
                          </p>

                          <p style="
                              color: #424242;
                              font-size: 16px;
                              margin-bottom: 0;
                            " class="textWrappingStyle">
                            {{ item.description }}
                          </p>

                        </div>
                      </v-col>
                      <v-col cols="4" md="4" lg="4" xl="3" class="pl-2 pr-0">
                        <div class="d-flex flex-row justify-end mt-2">
                          <div class="d-flex flex-column justify-space-between" style="row-gap: 1.5rem">
                            <p style="font-size: 16px; margin-bottom: 0" class="textWrappingStyle">
                              {{
                                item.fileTotal > 1
                                  ? item.fileTotal + " " + $t("Items")
                                  : item.fileTotal === 1
                                    ? item.fileTotal + " " + $t("Item")
                                    : item.fileTotal + " " + $t("NoItem")
                              }}
                              /
                              {{ item.totalDuration }}
                            </p>
                            <p style="font-size: 16px; margin-bottom: 0" class="textWrappingStyle">
                              {{ $t("enddate") }}:
                              {{ formatDate(item.endDateTime) }}
                            </p>
                          </div>
                          <v-icon color="#424242" class="ml-2">
                            mdi-chevron-right
                          </v-icon>


                        </div>
                      </v-col>
                    </v-row>
                  </template>

                  <div style="background-color: #42424214; padding-bottom: 20px">
                    <div style="background-color: #ffffff; padding-bottom: 20px"></div>
                    <v-row v-show="preTestFlag" class="mt-3">
                      <v-col cols="12" class="pl-10 pr-10">
                        <div class="videoIconContainer">
                          <v-img src="@/assets/Pre-Post-Test.png" alt="Logo" class="video_Icon"
                            style="width: 17px; height: 21px" />
                          <span class="labelVideo">
                            {{ $t("pretest") }}
                          </span>
                        </div>
                      </v-col>
                    </v-row>
                    <div class="ml-10 mr-10 mt-3">
                      <v-card style="border-radius: 16px" v-if="preTestFlag" height="110px" width="1204px" @click="
                        clickPreTest(PreTestdata, item.assignmentCourseID)
                        " class="d-flex align-center">
                        <template>
                          <v-row rows="12" lg="12" md="12" sm="12" no-gutters>
                            <v-col cols="9" lg="9" md="9" class="py-0">
                              <v-row align="center" no-gutters>
                                <v-col cols="auto" class="ml-3 py-1 d-flex align-center">
                                  <v-img src="@/assets/images/pretesticon_0.png" class="card-image" />
                                </v-col>
                                <v-col class="ml-5">
                                  <div class="text-left" style="color: #424242">
                                    <p style="font-size: 18px" class="mb-0">
                                      {{ PreTestdata.quizName }}
                                    </p>
                                    <p style="font-size: 13px" class="mb-0">
                                      {{ $t("questionsm") }} :
                                      <span style="font-weight: bold; color: black">
                                        {{ PreTestdata.totalQuestion }}
                                      </span>
                                      {{ " / " }} {{ $t("limited") }} :
                                      <span style="font-weight: bold; color: black">
                                        {{ PreTestdata.limitedSubmit }}
                                      </span>
                                    </p>
                                    <p style="font-size: 13px" class="mb-0">
                                      {{ $t("latestrating") }}
                                      <span style="font-weight: bold; color: black">
                                        {{ PreTestdata.latestRating }}
                                      </span>
                                    </p>
                                    <p style="font-size: 13px" class="mb-0">
                                      {{ $t("status") }} :
                                      <span v-if="PreTestdata.status === 'Pass'" style="
                                          color: #4FB050;
                                          font-weight: bold;
                                        ">
                                        {{ $t("pass") }}
                                      </span>
                                      <span v-else-if="
                                        PreTestdata.status === 'Fail'
                                      " style="
                                          color: #ef0404;
                                          font-weight: bold;
                                        ">
                                        {{ $t("fail") }}
                                      </span>
                                      <span v-else style="font-weight: bold;color: #2680EB;">
                                        {{ $t("notstarted") }}
                                      </span>
                                    </p>
                                  </div>
                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="3" md="3" lg="3" class="d-flex justify-end align-center">
                              <div style="padding-right: 20px">
                                <v-img v-if="
                                  PreTestdata.type == 'quiz' &&
                                  PreTestdata.completed == false
                                " src="@/assets/images/quiz_NS.svg" width="33px" height="33px"
                                  style="margin-right: 2px !important"></v-img>
                                <v-img v-if="
                                  PreTestdata.type == 'preQuiz' &&
                                  PreTestdata.completed == false
                                " src="@/assets/postquest.png" width="33px" height="33px"
                                  style="margin-right: 2px !important"></v-img>
                                <v-img style="font-size: 37px !important" v-if="
                                  PreTestdata.type == 'preQuiz' &&
                                  PreTestdata.completed == true &&
                                  PreTestdata.completedCount != 0
                                " src="@/assets/rightgreen.png" width="33px" height="33px" slot="prependIcon"
                                  color="#4FB14E"></v-img>

                                <v-img style="font-size: 37px !important" v-if="
                                  PreTestdata.type == 'preQuiz' &&
                                  PreTestdata.completed == true &&
                                  PreTestdata.completedCount == 0
                                " src="@/assets/redcross.png" width="33px" height="33px" slot="prependIcon"
                                  color="#D52A2A">
                                </v-img>

                              </div>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card>
                    </div>

                    <div class="mt-5" v-show="articleflag">
                      <v-col cols="12" class="pl-7 pr-8">
                        <div class="videoIconContainer">
                          <v-img src="@/assets/Article.png" alt="Logo" class="video_Icon" />
                          <span class="labelVideo">
                            {{ $t("article") }}
                          </span>
                        </div>
                      </v-col>
                    </div>
                    <div class="ml-10 mr-10 mt-3">
                      <v-card style="border-radius: 16px" v-show="articleflag" height="110px" width="1204px"
                        @click="clickArticle(Articledata)">
                        <template>
                          <v-row align="center" no-gutters>
                            <v-col cols="8" md="8" lg="8" xl="9" class="d-flex align-center pl-3 mt-3" style="
                                gap: 1rem;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                white-space: nowrap;
                              ">
                              <v-img :src="Articledata.optimizedLink
                                ? Articledata.optimizedLink
                                : require('@/assets/images/article_c.svg')
                                " alt="Logo" contain class="article-image"></v-img>

                              <div style="
                                  min-height: 79px;
                                  row-gap: 1.5rem;
                                  max-width: 750px;
                                " class="d-flex flex-column mt-1" :style="$vuetify.breakpoint.mdAndUp &&
                                  $vuetify.breakpoint.lgAndDown
                                  ? 'width: 300px'
                                  : $vuetify.breakpoint.smAndDown
                                    ? 'width: 240px'
                                    : 'auto'
                                  ">
                                <p style="
                                    color: #424242;
                                    font-size: 17px;
                                    margin-bottom: 0;
                                  " class="textWrappingStyle">
                                  {{ Articledata.fileName }}
                                </p>
                              </div>
                            </v-col>
                            <v-col cols="4" md="4" lg="4" xl="3" class="d-flex justify-end align-center mt-3">
                              <div style="margin-right: 20px" v-if="Articledata.type == 'article'"
                                class="article-container">
                                <v-img v-if="
                                  Articledata.type == 'article' &&
                                  !Articledata.isCompleted
                                " src="@/assets/images/articleNotStarted.svg" width="32px" height="32px"></v-img>
                                <v-img v-if="
                                  Articledata.type == 'article' &&
                                  Articledata.isCompleted
                                " src="@/assets/images/articleComplete.svg" width="32px" height="32px"></v-img>
                              </div>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card>
                    </div>

                    <v-row>
                      <v-col cols="12" class="pl-10 pr-10 pt-6" v-show="courseChildItems.length > 0">
                        <div class="videoIconContainer">
                          <v-img src="@/assets/Video.png" alt="Logo" class="video_Icon" />
                          <span class="labelVideo">
                            {{ $t("video") }}
                          </span>
                        </div>
                      </v-col>
                      <v-col v-for="(dataItem, index) in courseChildItems" :key="index" cols="12"
                        @click="checkContentType(dataItem, index)">
                        <div class="ml-10 mr-10">
                          <v-card style="border-radius: 16px; cursor: pointer" height="112px" width="1204px"
                            :style="isVideoLocked(index) ? { opacity: 0.6 } : {}"
                            class="d-flex justify-center align-center">
                            <template>
                              <v-row align="center" no-gutters>
                                <v-col cols="8" md="8" lg="8" xl="9" class="d-flex align-center pl-3" style="
                                    gap: 1rem;
                                    overflow: hidden;
                                    text-overflow: ellipsis;
                                    white-space: nowrap;
                                  ">
                                  <v-img :src="dataItem.pictureBackground
                                    ? dataItem.pictureBackground
                                    : require('@/assets/coursedefaultimage.png')
                                    " alt="Logo" contain class="course-image"></v-img>
                                  <div style="
                                      min-height: 79px;
                                      row-gap: 0.2rem;
                                      max-width: 750px;
                                    " class="d-flex flex-column mt-1" :style="$vuetify.breakpoint.mdAndUp &&
                                      $vuetify.breakpoint.lgAndDown
                                      ? 'width: 300px'
                                      : $vuetify.breakpoint.smAndDown
                                        ? 'width: 240px'
                                        : 'auto'
                                      ">
                                    <p style="
                                        color: #424242;
                                        font-size: 16px;
                                        margin-bottom: 0;
                                      " class="textWrappingStyle mt-2">
                                      {{ dataItem.title }}
                                    </p>
                                    <p style="
                                        color: #424242;
                                        font-size: 16px;
                                        margin-bottom: 0;
                                      " class="textWrappingStyle">
                                      {{ dataItem.duration }}
                                      {{ $t("minutes") }}
                                    </p>
                                  </div>
                                </v-col>
                                <v-col cols="4" md="4" lg="4" xl="3" class="d-flex justify-end align-center">
                                  <div style="padding-right: 20px">
                                    <!-- F02 DSD -->
                                    <v-icon v-if="isVideoLocked(index)" color="#9E9E9E" size="32"
                                      data-testid="video-lock">mdi-lock</v-icon>
                                    <v-img v-if="
                                      !isVideoLocked(index) &&
                                      dataItem.type == 'video' &&
                                      dataItem.isComplete == null &&
                                      dataItem.progress == null
                                    " style="font-size: 37px !important" slot="prependIcon" color="#008AFF"
                                      src="@/assets/VideoPlay.png.svg" width="32px" height="32px"></v-img>
                                    <!-- In Progres -->
                                    <v-img v-if="
                                      !isVideoLocked(index) &&
                                      dataItem.type == 'video' &&
                                      dataItem.isComplete == false &&
                                      dataItem.progress != null
                                    " style="font-size: 37px !important" slot="prependIcon" color="#E0BF0B"
                                      src="@/assets/yelloVideoPlay.png" width="32px" height="32px"></v-img>
                                    <!-- Complete -->
                                    <v-img v-if="
                                      !isVideoLocked(index) &&
                                      dataItem.type == 'video' &&
                                      dataItem.isComplete == true
                                    " style="font-size: 37px !important" slot="prependIcon" color="#4FB14E"
                                      src="@/assets/rightgreen.png" width="32px" height="32px"></v-img>
                                  </div>
                                </v-col>
                              </v-row>
                            </template>
                          </v-card>
                        </div>
                      </v-col>
                    </v-row>

                    <div class="mt-5" v-show="postTestFlag">
                      <v-col cols="12" class="pl-7 pr-8">
                        <div class="videoIconContainer">
                          <v-img src="@/assets/Pre-Post-Test.png" alt="Logo" class="video_Icon" />
                          <span class="labelVideo">
                            {{ $t("posttest") }}
                          </span>
                        </div>
                      </v-col>
                    </div>
                    <div class="ml-10 mr-10 mt-3">
                      <v-card style="border-radius: 16px" v-if="postTestFlag" height="110px" width="1204px"
                        class="d-flex justify-center align-center" @click="
                          clickPostTest(PostTestdata, item.assignmentCourseID)
                          ">
                        <template>
                          <v-row>
                            <v-col cols="9" md="9" lg="9" class="py-0">
                              <v-row align="center" no-gutters>
                                <v-col cols="auto" class="ml-3 py-1 d-flex align-center">
                                  <v-img v-if="
                                    PostTestdata.type === 'quiz' ||
                                    PostTestdata.type === 'preQuiz'
                                  " src="@/assets/images/posttesticon_0.png" class="card-image"></v-img>
                                </v-col>
                                <v-col class="ml-5">
                                  <div class="text-left" style="color: #424242">
                                    <p style="font-size: 18px" class="mb-0">
                                      {{ PostTestdata.quizName }}
                                    </p>
                                    <p style="font-size: 13px" class="mb-0">
                                      {{ $t("questionsm") }} :
                                      <span style="font-weight: bold; color: black">
                                        {{ PostTestdata.totalQuestion }}
                                      </span>
                                      {{ " / " }} {{ $t("limited") }} :
                                      <span style="font-weight: bold; color: black">
                                        {{ PostTestdata.limitedSubmit }}
                                      </span>
                                    </p>
                                    <p style="font-size: 13px" class="mb-0">
                                      {{ $t("latestrating") }} :
                                      <span style="font-weight: bold; color: black">
                                        {{ PostTestdata.latestRating }}
                                      </span>
                                    </p>
                                    <p style="font-size: 13px" class="mb-0">
                                      {{ $t("status") }} :
                                      <span v-if="PostTestdata.status === 'Pass'" style="
                                          color: #4FB050;
                                          font-weight: bold;
                                        ">
                                        {{ $t("pass") }}
                                      </span>
                                      <span v-else-if="
                                        PostTestdata.status === 'Fail'
                                      " style="
                                          color: #ef0404;
                                          font-weight: bold;
                                        ">
                                        {{ $t("fail") }}
                                      </span>
                                      <span v-else style="font-weight: bold;color: #2680EB;">
                                        {{ $t("notstarted") }}
                                      </span>
                                    </p>
                                  </div>

                                </v-col>
                              </v-row>
                            </v-col>
                            <v-col cols="3" md="3" lg="3" class="d-flex justify-end align-center">
                              <div style="padding-right: 20px">
                                <v-img v-if="
                                  PostTestdata.type == 'quiz' &&
                                  PostTestdata.completed == false
                                " src="@/assets/postquest.png" width="33px" height="33px"
                                  style="margin-right: 2px !important"></v-img>
                                <v-img v-if="
                                  PostTestdata.type == 'preQuiz' &&
                                  PostTestdata.completed == false
                                " src="@/assets/postquest.png" width="33px" height="33px"
                                  style="margin-right: 2px !important"></v-img>
                                <v-img v-if="
                                  PostTestdata.type == 'quiz' &&
                                  PostTestdata.completed == true &&
                                  PostTestdata.completedCount != 0
                                " src="@/assets/rightgreen.png" width="33px" height="33px"
                                  style="font-size: 37px !important" slot="prependIcon" color="#4FB14E"></v-img>
                                <v-img v-if="
                                  PostTestdata.type == 'preQuiz' &&
                                  PostTestdata.completed == true &&
                                  PostTestdata.completedCount != 0
                                " src="@/assets/rightgreen.png" width="33px" height="33px"
                                  style="font-size: 37px !important" slot="prependIcon" color="#4FB14E"></v-img>

                                <!-- selectedColor -->
                                <!-- Completed but fail quiz -->
                                <v-img v-if="
                                  PostTestdata.type == 'quiz' &&
                                  PostTestdata.completed == true &&
                                  PostTestdata.completedCount == 0
                                " src="@/assets/redcross.png" width="33px" height="33px"
                                  style="font-size: 37px !important" slot="prependIcon" color="#D52A2A"></v-img>
                                <v-img v-if="
                                  PostTestdata.type == 'preQuiz' &&
                                  PostTestdata.completed == true &&
                                  PostTestdata.completedCount == 0
                                " src="@/assets/redcross.png" width="33px" height="33px"
                                  style="font-size: 37px !important" slot="prependIcon" color="#D52A2A"></v-img>
                              </div>
                            </v-col>
                          </v-row>
                        </template>
                      </v-card>
                    </div>
                    <!-- F07 DSD: แบบประเมินความพึงพอใจหลักสูตร (DSD-07) -->
                    <template v-if="showEvaluationCard(item.assignmentCourseID)">
                      <div class="mt-5">
                        <v-col cols="12" class="pl-7 pr-8">
                          <div class="videoIconContainer">
                            <v-icon small color="#ffffff">mdi-star-outline</v-icon>
                            <span class="labelVideo">
                              {{ $t("courseevaluation") }}
                            </span>
                          </div>
                        </v-col>
                      </div>
                      <div class="ml-10 mr-10 mt-3">
                        <v-card data-testid="course-evaluation-card" class="d-flex align-center eval-card"
                          :class="{ 'eval-card--static': evaluationState(item.assignmentCourseID) !== 'open' }"
                          :aria-disabled="evaluationState(item.assignmentCourseID) === 'locked' ? 'true' : null"
                          v-on="evaluationCardListeners(item.assignmentCourseID)">
                          <div class="d-flex align-start pa-4" style="width: 100%">
                            <v-icon v-if="evaluationState(item.assignmentCourseID) === 'locked'" size="40"
                              color="#9E9E9E" class="mr-4">mdi-lock-outline</v-icon>
                            <v-icon v-else-if="evaluationState(item.assignmentCourseID) === 'open'" size="40"
                              color="#A6CC39" class="mr-4">mdi-star-outline</v-icon>
                            <v-icon v-else size="40" color="#4FB050" class="mr-4">mdi-check-circle</v-icon>
                            <div class="text-left" style="color: #424242; min-width: 0">
                              <p style="font-size: 18px" class="mb-1">{{ $t("courseevaluation") }}</p>
                              <p v-if="evaluationState(item.assignmentCourseID) === 'locked'" class="mb-0"
                                style="font-size: 14px; color: #616161">
                                {{ $t("evalaftercomplete") }}
                              </p>
                              <v-btn v-else-if="evaluationState(item.assignmentCourseID) === 'open'" color="#A6CC39"
                                height="36" class="text-capitalize white--text" style="border-radius: 8px"
                                @click.stop="openCourseEvaluation(evaluationOf(item.assignmentCourseID))">
                                {{ $t("evaldo") }}
                              </v-btn>
                              <p v-else-if="evaluationState(item.assignmentCourseID) === 'submitted'" class="mb-0"
                                style="font-size: 14px; color: #424242">
                                {{ $t("evalsubmitted", { date: evaluationSubmitDateText(item.assignmentCourseID) }) }}
                              </p>
                            </div>
                          </div>
                        </v-card>
                      </div>
                    </template>
                  </div>
                </v-list-group>
              </v-list>
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <videoPlay ref="videoPlay" :show="showVideoDialog" @close="showVideoDialog = false" :videoName="videoName"
      :videoPlayerDialog="videoPlayerDialog" @updateProgressCircle="updateProgressCircle" :videoFile="video_File"
      :contentid="contentId" :courseID="courseID" :lastWatchedTime="lastWatchedTime" :popupTime="popupTime"
      :formattedDateTime="formattedDateTime" :memberID="memberID" :video_page="2" :viewerFlag="viewerFlag"
      :prohibitForward="prohibitForward"></videoPlay>

    <!-- F07 DSD: แบบประเมินความพึงพอใจหลักสูตร -->
    <CourseEvaluationDialog :show="evaluationDialog" :course="evaluationCourse" @close="evaluationDialog = false"
      @submitted="onCourseEvaluationSubmitted" />
    <SuccessDialog :show="evaluationMessageDialog" :text="evaluationMessage" @close="evaluationMessageDialog = false" />

    <v-dialog width="470" v-model="quizShow" persistent>
      <v-card style="overflow: hidden !important; border-radius: 16px !important">
        <v-card-title style="font-size: 20px; color: #363636">
          <v-row class="mt-1 mb-1">
            <v-col style="text-align: center">
              <p class="mb-2 text-break">{{ $t(quizShowText, { title: lockedVideoTitle }) }}</p>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions style="justify-content: center">
          <v-btn @click="quizShow = false" color="#A6CC39" style="font-size: 20px; border-radius: 8px"
            class="text-capitalize white--text mb-2 mt-2 login-phone">{{ $t("ok") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- F05 DSD: รายละเอียดหลักสูตร (UX10/UX11/UX13) -->
    <v-dialog v-model="courseInfoDialog" max-width="720" scrollable :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card data-testid="dlg-course-info" :tile="$vuetify.breakpoint.xsOnly"
        :style="$vuetify.breakpoint.xsOnly ? { borderRadius: '0' } : { borderRadius: '16px' }">
        <v-card-title class="d-flex flex-nowrap" style="font-size: 20px; color: #363636">
          <span class="text-truncate course-info-title">{{ $t("coursedetails") }}</span>
          <v-spacer></v-spacer>
          <v-btn icon :aria-label="$t('close')" @click="closeCourseInfo">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-4 course-info-body">
          <!-- loading -->
          <div v-if="courseInfoLoading" class="d-flex align-center justify-center" style="min-height: 160px">
            <v-progress-circular indeterminate color="#a6cc39"></v-progress-circular>
          </div>
          <!-- error -->
          <div v-else-if="courseInfoError" class="d-flex flex-column align-center justify-center text-center"
            style="min-height: 160px">
            <p class="mb-3 text-break" style="font-size: 15px; color: #424242">{{ $t("courseinfoloaderror") }}</p>
            <v-btn outlined color="#A6CC39" class="text-capitalize" @click="retryCourseInfo">{{ $t("retry") }}</v-btn>
          </div>
          <!-- data -->
          <div v-else-if="courseInfoData">
            <!-- 1. ชื่อหลักสูตร -->
            <div class="mb-4">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("coursename") }}</p>
              <p class="mb-0 course-info-text text-break" style="font-size: 15px; color: #424242">{{ ciText(ci.courseName) }}</p>
              <v-chip v-if="ciIsDsd" small label color="#a6cc39" text-color="white" class="mt-1"
                data-testid="course-info-dsd-chip">{{ $t("dsdcourse") }}</v-chip>
            </div>
            <!-- 2. หัวข้อวิชา -->
            <div v-if="showAdminSection(ci.topics)" class="mb-4" data-testid="course-info-section-topics">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("coursetopics") }}</p>
              <p class="mb-0 course-info-text text-break" style="font-size: 15px; color: #424242">{{ ciText(ci.topics) }}</p>
            </div>
            <!-- 2b. เนื้อหาในหลักสูตร -->
            <div class="mb-4">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("coursecontents") }}</p>
              <template v-if="ciContents.length > 0">
                <div v-for="(c, idx) in ciContents" :key="'ci-c-' + idx" class="d-flex align-start mb-1"
                  style="font-size: 15px; color: #424242">
                  <v-icon small class="mr-2 mt-1">{{
                    c.type === "video" ? "mdi-play-circle-outline" : "mdi-file-document-outline"
                  }}</v-icon>
                  <span class="text-break flex-grow-1" style="min-width: 0">{{ c.title }}</span>
                  <span v-if="c.durationSeconds != null" class="ml-2">{{
                    formatContentDuration(c.durationSeconds)
                  }}</span>
                </div>
              </template>
              <p v-else class="mb-0" style="font-size: 15px; color: #424242">{{ $t("NoItem") }}</p>
            </div>
            <!-- 3. จำนวนชั่วโมง -->
            <div class="mb-4">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("coursehours") }}</p>
              <p class="mb-0 course-info-text text-break" style="font-size: 15px; color: #424242"
                data-testid="course-info-hours">{{ hoursText() }}</p>
              <p v-if="ci.unknownDurationCount > 0" class="caption orange--text text--darken-3 mb-0">
                <v-icon small color="orange darken-3" class="mr-1">mdi-alert-outline</v-icon>{{
                  $t("unknowndurationnote", { n: ci.unknownDurationCount })
                }}
              </p>
            </div>
            <!-- 4. วิทยากร -->
            <div v-if="showAdminSection(ci.instructorName)" class="mb-4" data-testid="course-info-section-instructor">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("instructorname") }}</p>
              <p class="mb-0 course-info-text text-break" style="font-size: 15px; color: #424242">{{ ciText(ci.instructorName) }}</p>
            </div>
            <!-- 5. เนื้อหาวิชาพอสังเขป -->
            <div v-if="showAdminSection(ci.description)" class="mb-4" data-testid="course-info-section-summary">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("coursesummary") }}</p>
              <p class="mb-0 course-info-text text-break" style="font-size: 15px; color: #424242">{{ ciText(ci.description) }}</p>
            </div>
            <!-- 6. รูปแบบข้อสอบและจำนวนข้อ -->
            <div class="mb-4">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("examformat") }}</p>
              <p v-if="ciQuizzes.length === 0" class="mb-0" style="font-size: 15px; color: #424242">{{ $t("noquiz") }}
              </p>
              <template v-else>
                <div v-for="(q, qi) in ciQuizzes" :key="'ci-q-' + qi" class="mb-2"
                  style="font-size: 15px; color: #424242"
                  :data-testid="'course-info-quiz-' + (q.quizTypeID == null ? 'none' : q.quizTypeID)">
                  <p class="mb-0 font-weight-medium text-break">{{ quizHeading(q) }}</p>
                  <p class="mb-0 text-break">{{ quizCountLine(q) }}</p>
                </div>
              </template>
            </div>
            <!-- 7. เกณฑ์การวัดและประเมินผล -->
            <div v-if="ciIsDsd || hasText(ci.evaluationCriteria) || autoCriteria().length > 0" class="mb-4"
              data-testid="course-info-section-evaluation">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("evaluationcriteria") }}
              </p>
              <p v-if="ciIsDsd || hasText(ci.evaluationCriteria)" class="mb-0 course-info-text text-break"
                style="font-size: 15px; color: #424242">{{ ciText(ci.evaluationCriteria) }}</p>
              <ul class="mb-0" style="font-size: 15px; color: #424242">
                <li v-for="(line, li) in autoCriteria()" :key="'ci-a-' + li" class="text-break">{{ line }}</li>
              </ul>
            </div>
            <!-- 8. คุณสมบัติผู้เข้าอบรม -->
            <div v-if="showAdminSection(ci.learnerQualification)" class="mb-4"
              data-testid="course-info-section-qualification">
              <p class="font-weight-bold mb-1" style="font-size: 16px; color: #424242">{{ $t("learnerqualification")
              }}</p>
              <p class="mb-0 course-info-text text-break" style="font-size: 15px; color: #424242">{{ ciText(ci.learnerQualification) }}</p>
            </div>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer v-if="!$vuetify.breakpoint.xsOnly"></v-spacer>
          <v-btn color="#A6CC39" :block="$vuetify.breakpoint.xsOnly" style="border-radius: 8px"
            class="text-capitalize white--text" @click="closeCourseInfo">{{ $t("close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import videoPlay from "../Library/_subLibrary/_path/_video/videoPlay.vue";
import CourseEvaluationDialog from "./CourseEvaluationDialog.vue";
import i18n from "@/translate/i18n";
export default {
  components: {
    videoPlay,
    CourseEvaluationDialog,
  },
  data() {
    return {
      item: {},
      search: "",
      searchtype: "",
      courseCategoryName: null,
      courseTemp: {},
      rq_courseId: 0,
      loading: true,
      quizShowText: null,
      quizShow: false,
      prequizCompleted: true,
      //video dialog data
      popupTime: 0,
      videoDescription: "",
      lastWatchedTime: "",
      videoName: "",
      contentId: 0,
      video_File: "",
      courseID: 0,
      memberID: "",
      //...................
      videoPlayerDialog: false,
      showVideoDialog: false,
      //...end of video dialog data
      notStartedCourseID: [],
      inProgressCourseID: [],
      completedCourseID: [],
      delayCourseID: [],
      showCourseList: false,
      selectedColor: null,
      tempCourseItems: [], //raw uncategorize(not started, inprogress, etc...) courses
      courseChildItems: [],
      courseItems: [],
      viewerFlag: false,
      // F02 DSD
      prohibitForward: false,
      openingVideo: false,
      lockedVideoTitle: "",
      // F05 DSD — dialog รายละเอียดหลักสูตร
      courseInfoDialog: false,
      courseInfoLoading: false,
      courseInfoError: false,
      courseInfoData: null,
      courseInfoReqId: null,
      courseInfoReqSeq: 0,
      // F07 DSD — แบบประเมินความพึงพอใจหลักสูตร
      evaluationStatusList: [],
      evaluationDialog: false,
      evaluationCourse: {},
      evaluationMessage: "",
      evaluationMessageDialog: false,
      breadcrumbs: [
        {
          text: "course",
        },
      ],
      cardItems: [
        {
          bgcolor: "#008AFF",
          image: require("@/assets/images/notStarted.svg"),
          title: "notstarted",
          name: "notstarted",
          selected: false,
          courseCount: 0,
        },
        {
          bgcolor: "#E0BF0B",
          image: require("@/assets/images/inProgress.svg"),
          title: "inprogress",
          name: "inprogress",
          selected: false,
          courseCount: 0,
        },
        {
          bgcolor: "#4FB14E",
          image: require("@/assets/images/complete.svg"),
          title: "complete",
          name: "complete",
          selected: false,
          courseCount: 0,
        },
        {
          bgcolor: "#D52A2A",
          image: require("@/assets/images/delay.svg"),
          title: "delay",
          name: "delay",
          selected: false,
          courseCount: 0,
        },
      ],
      preTestFlag: false,
      PreTestdata: {},
      postTestFlag: false,
      PostTestdata: {},
      articleflag: false,
      Articledata: {},
      formattedDateTime: "",
      setting: {},
    };
  },
  computed: {

    hasVideo() {
      console.log("Checking................", this.courseChildItems)
      return this.courseChildItems.some(item => item.type === 'video' && item.data);
    },

    textClass() {
      return this.$vuetify.breakpoint.mdAndUp ? "truncate" : "full-text";
    },
    searchInLists() {
      if (this.search) {
        let searchItems = [];
        searchItems = this.courseItems.filter((x) =>
          x.courseName.toLowerCase().includes(this.search.toLowerCase())
        );
        return searchItems;
      } else {
        return this.courseItems;
      }
    },
    // F05 DSD
    ci() {
      return this.courseInfoData || {};
    },
    ciIsDsd() {
      return this.ci.dsdMode === true;
    },
    ciContents() {
      return Array.isArray(this.ci.contents) ? this.ci.contents : [];
    },
    ciQuizzes() {
      return Array.isArray(this.ci.quizzes) ? this.ci.quizzes : [];
    },
  },
  watch: {
    // F05 DSD — ปิด dialog แล้วล้างข้อมูลเก่า และทิ้ง response ที่ยังค้าง
    courseInfoDialog(val) {
      if (!val) {
        this.courseInfoReqSeq++;
        this.courseInfoReqId = null;
        this.courseInfoData = null;
        this.courseInfoLoading = false;
        this.courseInfoError = false;
      }
    },
  },
  mounted() {
    (async () => {
      await this.getProgressCirleCourseData();
      await this.getProgressCountName();
      await this.getCourseEvaluationStatus(); // F07 DSD
      this.autoPromptCourseEvaluation();
      this.getNotificationCount();
      this.getFavourite();

      if (this.$route.params.reQuiz == "requiz") {
        this.loading = true;
        this.selectCourseCategory(this.$route.params.courseTemp);
      }
    })().then(() => {
      this.mountDone = true;
    });
  },

  methods: {
    formatDate(changeDate) {

      let returndata;
      let language = i18n.locale;

      if (language === "th") {
        const formatter = new Intl.DateTimeFormat("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        returndata = formatter.format(new Date(changeDate));
      } else {
        const formatter = new Intl.DateTimeFormat("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
        });
        returndata = formatter.format(new Date(changeDate));
      }

      return returndata;
    },
    updateProgressCircle() {
      switch (this.courseCategoryName) {
        case "notstarted":
          this.showCourseList = false;
          this.updateCourseCategoryMethodCall();
          break;
        case "complete":
          this.getCourseDetailFiles(this.courseID);
          break;
        case "inprogress":
          this.getCourseDetailFiles(this.courseID);
          break;
        case "delay":
          this.getCourseDetailFiles(this.courseID);
          break;
      }
    },
    formatDateTime(dateTime) {
      const options = {
        year: "2-digit",
        month: "2-digit",
        day: "2-digit",
        hour: "numeric",
        minute: "numeric",
      };
      const dateTimeString = dateTime.toLocaleDateString("en-US", options);
      return dateTimeString.replaceAll("/", "-");
    },
    async switchVideoCase(item) {
      if (this.prequizCompleted === true) {
        if (this.openingVideo) return; // F02 DSD — กันกดซ้ำระหว่างโหลด (U7)
        this.openingVideo = true;
        try {
          let date1 = new Date();
          this.formattedDateTime = this.formatDateTime(date1);
          this.memberID = item.memberID;
          this.$refs.videoPlay.GetCommentsForVideo(item.videoID);
          this.video_File = item.videoFile;
          this.contentId = item.videoID;
          this.videoName = item.videoName;
          this.viewerFlag = item.viewerFlag;
          if (item.progress == "1" || item.progress == "1.00") {
            this.lastWatchedTime = 0;
          } else {
            this.lastWatchedTime = item.lastViewTime;
          }
          this.courseID = item.assignmentCourseID;
          this.popupTime = item.popupTime * 60; //change mins to seconds
          // F02 DSD — โหลดสถานะการดูก่อนเปิดตัวเล่น
          this.prohibitForward = item.prohibit === true;
          if (this.prohibitForward) {
            await this.$refs.videoPlay.loadWatchState(item.assignmentCourseID, item.videoID);
          } else {
            this.$refs.videoPlay.watchState = null;
          }
          this.showVideoDialog = true; // F02 DSD — ย้ายมาท้าย หลังตั้ง state ครบ
        } finally {
          this.openingVideo = false;
        }
      } else {
        this.quizShowText = "lblpretestalert";
        this.quizShow = true;
      }
    },
    async clickPostTest(item, courseid) {
      await this.GetQuizSetting(item.quizId);
      console.log("article data", this.Articledata);
      console.log("prequiz", this.Articledata.isCompleted, this.prequizCompleted);
      if (item.fullLimit) {
        this.quizShowText = "quizfulllimittext";
        this.quizShow = true;
        return false;
      }
      if (this.setting.showQuizFinishWatching === true &&
        (this.prequizCompleted === false ||
          (this.courseChildItems.length > 0 && item.canDoWatchFinish !== false) ||
          (this.prequizCompleted === true && this.Articledata.isCompleted === false) ||
          item.canDoInprogress !== false)) {

        this.quizShowText = "quizfinishaftercontent";
        this.quizShow = true;
        return false;
      }

      else {
        this.$router.push({
          name: "course-quiz",
          query: {
            quizId: item.quizId,
            rq_courseId: courseid,
            courseTemp: this.courseTemp,
            quizIsPassed: item.completedCount, // 1 = pass 1 time, 2 = pass 2 times
            quizTypeID: item.quizTypeID,
          },
        });
      }
    },
    clickArticle(item) {
      if (this.prequizCompleted === true) {
        this.$router.push({
          name: "course-article",
          query: {
            assignmentArticleID: item.assignmentArticleID,
            courseID: item.courseID,
            memberID: item.memberID,
          },
        });
      } else {

        this.quizShowText = "lblpretestalert";
        this.quizShow = true;
      }
    },
    // F02 DSD — วิดีโอบังคับลำดับที่ยังมีวิดีโอก่อนหน้าไม่จบ
    isVideoLocked(index) {
      const item = this.courseChildItems[index];
      if (!item || item.mustWatch !== true || item.isComplete === true) return false;
      return this.courseChildItems.slice(0, index).some((v) => v.isComplete !== true);
    },
    checkContentType(item, index) {
      // AC-11: Pre-Test มาก่อน (switchVideoCase แสดง lblpretestalert)
      if (this.prequizCompleted !== true) {
        this.switchVideoCase(item);
        return;
      }
      if (this.isVideoLocked(index)) {
        const firstPending = this.courseChildItems
          .slice(0, index)
          .find((v) => v.isComplete !== true);
        // F02 DSD — title ว่าง/whitespace → ใช้ชื่อไฟล์วิดีโอแทน
        const pendingTitle = firstPending && typeof firstPending.title === "string" ? firstPending.title.trim() : "";
        const pendingVideoName = firstPending && typeof firstPending.videoName === "string" ? firstPending.videoName.trim() : "";
        this.lockedVideoTitle = pendingTitle || pendingVideoName || "";
        this.quizShowText = "lblmustwatchinorder";
        this.quizShow = true;
        return;
      }
      this.switchVideoCase(item);
    },
    clickPreTest(item, courseid) {
      if (item.fullLimit === false) {
        this.$router.push({
          name: "course-quiz",
          query: {
            quizId: item.quizId,
            rq_courseId: courseid,
            courseTemp: this.courseTemp,
            quizIsPassed: item.completedCount,
            quizTypeID: item.quizTypeID,
          },
        });
      } else {
        this.quizShowText = "quizfulllimittext";
        this.quizShow = true;
      }
    },

    closeDialog() {
      this.showVideoDialog = false;
      this.$refs.videoPlayer.pause();
    },
    async GetQuizSetting(quizId) {
      this.itemsList = [];
      this.loading = true;
      const request = {
        companyID: localStorage.getItem("companyID"),
        quizId: quizId,
      };
      await axios
        .post(`${this.web_urlV4}Quiz/GetQuizSettingForUser`, request)
        .then((response) => {
          if (response.data.status == 0) {
            this.setting = response.data.data;
          }
        })
        .catch((err) => {
          this.loading = false;
          throw err;
        });
    },

    getQuizStatus(quizData) {
      if (quizData.completed) {
        return quizData.completedCount ? "Pass" : "Fail";
      }
      return "Not Started";
    },

    buildPostTestData(quiz) {
      return {
        fileName: "Post-Quiz",
        type: "quiz",
        canDoInprogress: quiz.canDoInprogress,
        canDoWatchFinish: quiz.canDoWatchFinish,
        completed: quiz.completed,
        completedCount: quiz.completedCount,
        fullLimit: quiz.fullLimit,
        quizId: quiz.quizId,
        quizTypeID: 1,
        quizName: quiz.quizName,
        totalQuestion: quiz.totalQuestion,
        limitedSubmit: quiz.limitedSubmit,
        latestRating: quiz.latestRating,
        status: this.getQuizStatus(quiz),
      };
    },

    buildPreTestData(preQuiz) {
      return {
        fileName: "Pre-Quiz",
        type: "preQuiz",
        canDoInprogress: preQuiz.canDoInprogress,
        canDoWatchFinish: preQuiz.canDoWatchFinish,
        completed: preQuiz.completed,
        completedCount: preQuiz.completedCount,
        fullLimit: preQuiz.fullLimit,
        quizId: preQuiz.quizId,
        quizTypeID: 2,
        quizName: preQuiz.quizName,
        totalQuestion: preQuiz.totalQuestion,
        limitedSubmit: preQuiz.limitedSubmit,
        latestRating: preQuiz.latestRating,
        status: this.getQuizStatus(preQuiz),
      };
    },

    async getCourseDetailFiles(course_id) {
      this.courseChildItems = [];
      this.preTestFlag = false;
      this.PreTestdata = {};
      this.postTestFlag = false;
      this.PostTestdata = {};
      this.Articledata = {};
      this.articleflag = false;
      const request = {
        userID: Number.parseInt(localStorage.getItem("UserID")),
        companyId: localStorage.getItem("companyID"),
        courseId: course_id,
      };
      await this.$axios
        .post(`${this.web_urlV7}Contents/GetAssignmentVideoList`, request)
        .then((res) => {
          if (res.data.status == 0) {
            const data = res.data.data;
            const courseVideoFiles = data.progressData.map((v) => ({
              ...v,
              fileName: v.videoName,
              type: "video",
              title: v.title,
            }));
            if (data.article) {
              this.articleflag = true;
              this.Articledata = {
                fileName: data.article.title,
                type: "article",
                assignmentArticleID: data.article.assignmentArticleID,
                courseID: data.article.courseID,
                isCompleted: data.article.isCompleted,
                optimizedLink: data.article.optimizedLink,
                memberID: courseVideoFiles[0]?.memberID,
              };
            }
            if (data.quiz) {
              this.postTestFlag = true;
              this.PostTestdata = this.buildPostTestData(data.quiz);
            } else {
              this.postTestFlag = false;
            }
            if (data.preQuiz) {
              this.preTestFlag = true;
              this.prequizCompleted = data.preQuiz.completed;
              this.PreTestdata = this.buildPreTestData(data.preQuiz);
            } else {
              this.prequizCompleted = true;
              this.preTestFlag = false;
            }
            this.courseChildItems = courseVideoFiles;
            this.rq_courseId = course_id;
            this.checkCourseComplete(data);
          }
        });
    },

    checkCourseComplete(responseData) {
      if (this.courseCategoryName === "complete") return;

      const allVideoIsCompleted = responseData.progressData.some(
        (j) => j.isComplete === false || j.isComplete == null
      ) ? "false" : "true";
      const articleIsCompleted = responseData.article === null
        ? true
        : responseData.article.isCompleted;
      // TC-LMS-019 — Post-test ต้องผ่านเกณฑ์ (completedCount = จำนวนครั้งที่ผ่าน) ให้ตรงกับสถานะจาก API
      const quizIsCompleted = responseData.quiz == null ? true : responseData.quiz.completedCount > 0;
      const prequizIsCompleted = responseData.preQuiz == null ? true : responseData.preQuiz.completed;

      if (
        prequizIsCompleted === true &&
        allVideoIsCompleted === "true" &&
        quizIsCompleted === true &&
        articleIsCompleted === true
      ) {
        this.showCourseList = false;
        this.updateCourseCategoryMethodCall();
      }
    },

    async updateCourseCategoryMethodCall() {
      this.loading = true;
      await this.getProgressCirleCourseData();
      await this.getProgressCountName();
      await this.getCourseEvaluationStatus(); // F07 DSD
      this.autoPromptCourseEvaluation();
    },

    async getProgressCountName() {
      const request = {
        userId: Number.parseInt(localStorage.getItem("UserID")),
        companyId: localStorage.getItem("companyID"),
      };

      await this.$axios
        .post(`${this.web_urlV7}Contents/GetProgressCountName`, request)
        .then((res) => {
          if (res.data.status == 0) {
            this.tempCourseItems = res.data.data.map((v) => ({
              ...v,
              fileTotal:
                v.assignmentQuizCount +
                v.assignmentVideoCount +
                v.assignmentArticleCount,
              isOpen: false,
            }));
            this.loading = false;
          }
        });
    },

    async getProgressCirleCourseData() {
      const request = {
        userId: Number.parseInt(localStorage.getItem("UserID")),
        companyId: localStorage.getItem("companyID"),
      };

      await this.$axios
        .post(`${this.web_urlV5}Contents/GetUserProgressMobileFrist`, request)
        .then((res) => {
          if (res.data.status == 0) {
            this.cardItems.forEach((value) => {
              value.opencolse = false;
              if (value.name == "notstarted") {
                value.courseCount = res.data.data.notStarted.length;
              } else if (value.name == "inprogress") {
                value.courseCount = res.data.data.inProgress.length;
              } else if (value.name == "complete") {
                value.courseCount = res.data.data.completed.length;
              } else {
                value.courseCount = res.data.data.delay.length;
              }
            });

            this.notStartedCourseID = res.data.data.notStarted;
            this.inProgressCourseID = res.data.data.inProgress;
            this.completedCourseID = res.data.data.completed;
            this.delayCourseID = res.data.data.delay;
          }
        });
    },

    selectCourseCategory(v) {
      this.showCourseList = v.courseCount === 0 ? false : !v.selected;
      this.cardItems.forEach((value) => {
        if (value.name == v.name) {
          value.selected = !value.selected;
        } else {
          value.selected = false;
        }
      });
      this.selectedColor = v.bgcolor;

      if (this.showCourseList === true) {
        let rawData = this.tempCourseItems;

        let categorized = [];

        switch (v.name) {
          case "notstarted":
            categorized = rawData.filter((elem) => {
              return this.notStartedCourseID.some((ele) => {
                return ele.assignmentCourseID === elem.assignmentCourseID;
              });
            });
            break;
          case "inprogress":
            categorized = rawData.filter((elem) => {
              return this.inProgressCourseID.some((ele) => {
                return ele.assignmentCourseID === elem.assignmentCourseID;
              });
            });
            break;
          case "complete":
            categorized = rawData.filter((elem) => {
              return this.completedCourseID.some((ele) => {
                return ele.assignmentCourseID === elem.assignmentCourseID;
              });
            });

            break;
          case "delay":
            categorized = rawData.filter((elem) => {
              return this.delayCourseID.some((ele) => {
                return ele.assignmentCourseID === elem.assignmentCourseID;
              });
            });
            break;
        }
        this.courseCategoryName = v.name;

        this.courseTemp = {
          bgcolor: v.bgcolor,
          courseCount: v.courseCount,
          image: v.image,
          name: v.name,
          selected: false,
          title: v.title,
        };

        if (this.$route.params.reQuiz == "requiz") {
          this.getCourseDetailFiles(this.$route.params.rq_courseId);
          this.courseItems = categorized.map((x) => ({
            ...x,
            isOpen: this.$route.params.rq_courseId == x.assignmentCourseID,
          }));

          this.loading = false;
          this.$route.params.reQuiz = null;
        } else {
          this.courseItems = categorized.map((x) => ({
            ...x,
            isOpen: false,
          }));
        }
      }
    },
    // F05 DSD — รายละเอียดหลักสูตร (v7 Assignment/GetCourseInfo)
    openCourseInfo(courseId) {
      this.courseInfoData = null;
      this.courseInfoError = false;
      this.courseInfoReqId = courseId;
      this.courseInfoDialog = true;
      this.loadCourseInfo(courseId);
    },
    async loadCourseInfo(courseId) {
      const seq = ++this.courseInfoReqSeq;
      this.courseInfoLoading = true;
      this.courseInfoError = false;
      this.courseInfoData = null;
      const request = {
        userID: Number.parseInt(localStorage.getItem("UserID")),
        assignmentCourseID: courseId,
      };
      let data = null;
      try {
        const res = await this.$axios.post(
          `${this.web_urlV7}Assignment/GetCourseInfo`,
          request,
          { timeout: 10000 }
        );
        if (res.data.status == 0 && res.data.data) data = res.data.data;
      } catch (e) {
        data = null; // timeout / network / 401
      }
      // response ค้าง: ปิดไปแล้ว, เปิดคอร์สอื่น หรือมีคำขอใหม่กว่า → ทิ้ง
      if (
        !this.courseInfoDialog ||
        seq !== this.courseInfoReqSeq ||
        courseId !== this.courseInfoReqId
      )
        return;
      this.courseInfoLoading = false;
      if (data) this.courseInfoData = data;
      else this.courseInfoError = true;
    },
    retryCourseInfo() {
      if (this.courseInfoReqId != null) this.loadCourseInfo(this.courseInfoReqId);
    },
    closeCourseInfo() {
      this.courseInfoDialog = false;
    },
    hasText(v) {
      return typeof v === "string" && v.trim() !== "";
    },
    ciText(v) {
      return this.hasText(v) ? v : "-"; // ไม่ trim ค่าที่แสดง (คงบรรทัดตามต้นฉบับ)
    },
    showAdminSection(v) {
      return this.ciIsDsd || this.hasText(v); // A13
    },
    hoursText() {
      const t = this.ci.courseHoursText;
      if (typeof t !== "string" || t.indexOf(":") < 0) return "-";
      const parts = t.split(":");
      return this.$t("hoursminutesformat", {
        h: Number(parts[0]),
        m: Number(parts[1]),
      });
    },
    formatContentDuration(sec) {
      if (sec == null || isNaN(sec)) return "";
      const total = Math.max(0, Math.floor(Number(sec)));
      const h = Math.floor(total / 3600);
      const m = Math.floor((total % 3600) / 60);
      const s = total % 60;
      const pad = (n) => (n < 10 ? "0" + n : "" + n);
      return h > 0 ? h + ":" + pad(m) + ":" + pad(s) : m + ":" + pad(s);
    },
    quizTypeLabel(typeId) {
      if (typeId === 1) return this.$t("posttest");
      if (typeId === 2) return this.$t("pretest");
      if (typeId === 3) return this.$t("preposttest");
      return "";
    },
    quizHeading(q) {
      const label = this.quizTypeLabel(q.quizTypeID);
      return label ? label + " — " + (q.quizName || "") : q.quizName || "";
    },
    quizCountLine(q) {
      const parts = [this.$t("questioncount", { n: q.questionCount || 0 })];
      if (q.singleChoiceCount > 0)
        parts.push(this.$t("singlechoicecount", { n: q.singleChoiceCount }));
      if (q.multipleChoiceCount > 0)
        parts.push(this.$t("multiplechoicecount", { n: q.multipleChoiceCount }));
      if (q.subjectiveCount > 0)
        parts.push(this.$t("subjectivecount", { n: q.subjectiveCount }));
      return parts.join(" · ");
    },
    autoCriteria() {
      const lines = [];
      this.ciQuizzes.forEach((q) => {
        if (q.passingScore == null || q.fullScore == null || q.passingPercent == null) return;
        const label = this.quizTypeLabel(q.quizTypeID) || q.quizName || "";
        lines.push(
          label +
          ": " +
          this.$t("passingcriteria", {
            score: q.passingScore,
            full: q.fullScore,
            percent: Number(q.passingPercent).toFixed(2), // ค่าจาก API ตัดทิ้งแล้ว (D9) — ไม่คำนวณเอง
          })
        );
      });
      const w = this.ci.watchRule;
      if (w && w.requiredWatchPercent != null) {
        lines.push(this.$t("watchrequirement", { p: w.requiredWatchPercent }));
      }
      return lines;
    },
    // F07 DSD — แบบประเมินความพึงพอใจหลักสูตร (v7 CourseEvaluation)
    async getCourseEvaluationStatus() {
      const request = {
        userID: Number.parseInt(localStorage.getItem("UserID")),
        companyID: localStorage.getItem("companyID"),
        assignmentCourseID: 0,
      };
      try {
        const res = await this.$axios.post(
          `${this.web_urlV7}CourseEvaluation/GetCourseEvaluationStatus`,
          request,
          { timeout: 10000 }
        );
        this.evaluationStatusList =
          res.data.status == 0 && Array.isArray(res.data.data) ? res.data.data : [];
      } catch (e) {
        this.evaluationStatusList = []; // ไม่มีการ์ด/popup ไม่แสดง error
      }
    },
    evaluationOf(courseId) {
      return this.evaluationStatusList.find((x) => x.assignmentCourseID === courseId) || null;
    },
    showEvaluationCard(courseId) {
      // ปิด DSD แล้วแต่ส่งไปแล้ว ยังแสดง
      const ev = this.evaluationOf(courseId);
      return !!ev && (ev.evaluationEnabled === true || ev.submitted === true);
    },
    evaluationState(courseId) {
      const ev = this.evaluationOf(courseId);
      if (!ev) return null;
      if (ev.submitted) return "submitted";
      return ev.courseCompleted ? "open" : "locked";
    },
    evaluationCardListeners(courseId) {
      // คลิกการ์ดได้เฉพาะสถานะ "open"
      if (this.evaluationState(courseId) !== "open") return {};
      return { click: () => this.openCourseEvaluation(this.evaluationOf(courseId)) };
    },
    autoPromptCourseEvaluation() {
      // ไม่เปิดทับตัวเล่นวิดีโอ / popup quiz / dialog อื่น
      if (this.evaluationDialog || this.showVideoDialog || this.quizShow || this.courseInfoDialog) return;
      let key = null;
      let prompted = [];
      try {
        key = "courseEvalPrompted_" + localStorage.getItem("UserID");
        const arr = JSON.parse(localStorage.getItem(key) || "[]");
        if (Array.isArray(arr)) prompted = arr;
      } catch (e) {
        prompted = []; // อ่านไม่ได้ = ถือว่ายังไม่เคย prompt
      }
      const target = this.evaluationStatusList.find(
        (x) => x.evaluationEnabled && x.courseCompleted && !x.submitted && prompted.indexOf(x.assignmentCourseID) < 0
      );
      if (!target) return;
      try {
        localStorage.setItem(key, JSON.stringify(prompted.concat([target.assignmentCourseID])));
      } catch (e) {
        // เขียนไม่ได้ — ยัง prompt ครั้งนี้ได้
      }
      this.openCourseEvaluation(target);
    },
    openCourseEvaluation(ev) {
      if (!ev || this.evaluationDialog) return;
      this.evaluationCourse = { assignmentCourseID: ev.assignmentCourseID, courseName: ev.courseName };
      this.evaluationDialog = true;
    },
    onCourseEvaluationSubmitted(e) {
      this.evaluationDialog = false;
      this.evaluationMessage = this.$t(e && e.already ? "evalalreadysubmitted" : "evalsubmitsuccess");
      this.evaluationMessageDialog = true;
      this.getCourseEvaluationStatus(); // การ์ดเปลี่ยนเป็น "ส่งแล้ว" โดยไม่ reload
    },
    evaluationSubmitDateText(courseId) {
      const ev = this.evaluationOf(courseId);
      return ev && ev.submitDate ? this.formatDate(ev.submitDate) : "";
    },
  },
};
</script>

<style scoped>
.line-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  /* Number of lines to show */
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.iconmdileftright {
  margin-left: 20px;
}

.truncate {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  line-clamp: 1;
  line-height: 1.5;
  max-height: calc(1.4em * 1);
  white-space: normal;
}

.full-text {
  white-space: normal;
}

/* css:S7924 false positive: rgba(0,0,0,0.87) on an 8%-alpha #42424214 overlay
   renders at ~14:1 contrast; the linter doesn't resolve alpha compositing. */
::v-deep .list-Bg .v-list-group__header.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgba(0, 0, 0, 0.87);
  background-color: #42424214;
  height: 110px;
  border-radius: 16px;
}

::v-deep .list-Bg .v-list-group__header.v-list-item.v-list-item--active.v-list-item--link.theme--light {
  color: rgba(0, 0, 0, 0.87);
  background-color: #42424214;
  height: 100px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.custom-padding {
  border-radius: 8px;
  border-color: #c0c0c0;
  background-color: #42424214;
}

.description-text {
  font-size: 18px;
  color: #424242;
  text-align: right;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
  /* Allow cards to wrap to the next line if needed */
  justify-content: space-between;
}

::v-deep .theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  background-color: #42424208;
}

.courseImg {
  position: absolute;
  top: 35%;
  left: 48%;
  transform: translate(-50%, -48%);
}

.coursecounttext {
  text-align: center;
  font-size: 16px;
  color: #424242;
  margin-top: -13px;
}

.imgBg {
  height: 130px;
  opacity: 0.1;
  margin-bottom: 10px;
  border-radius: 8px;
  position: relative;
  z-index: 0 !important;
}

.countIconBtn {
  background-color: #ffffff;
  border-radius: 50px !important;
  box-shadow: unset;
}

::v-deep .primary--text {
  color: #424242 !important;
  caret-color: #424242 !important;
}

::v-deep .countIconBtn.theme--light.v-btn {
  color: #ffffff;
}

::v-deep .countIconBtn.theme--light.v-btn.v-btn--has-bg {
  background-color: #ffffff;
}

::v-deep .countIconBtn.v-btn--absolute.v-btn--right,
.v-btn--fixed.v-btn--right {
  right: -10px;
}

::v-deep .countIconBtn.v-btn--fab.v-size--x-small {
  height: 42px;
  width: 42px;
}

::v-deep .countIconBtn.v-btn--fab.v-size--x-small.v-btn--absolute.v-btn--top {
  top: -8px;
}

/* F05 DSD — รายละเอียดหลักสูตร */
.course-header-row {
  min-width: 0;
}

.course-info-btn {
  flex: 0 0 36px;
}

.course-info-title {
  min-width: 0;
}

.course-info-text {
  white-space: pre-line;
}
</style>

<style scoped>
::v-deep .overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar {
  width: 7px !important;
}

/* Track */
::v-deep .overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-track {
  width: 6px !important;
  background: #e6e6e6;
  border-left: 1px solid #dadada;
}

/* Handle */
::v-deep .overflow-y-auto.v-sheet.theme--light::-webkit-scrollbar-thumb {
  background: #b0b0b0;
  border: solid 2px #e6e6e6;
  border-radius: 7px;
}

::v-deep .overflow-y-auto.v-sheet.theme--light {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 10px;
  padding-bottom: 0px;
}

::v-deep .v-list {
  padding: 0;
}

.containerimage {
  margin-top: 3px;
  display: flex;
  flex-wrap: wrap;
  /* Allow cards to wrap to the next line if needed */
  justify-content: space-between;
}

.card-image {
  max-width: 156px;
  min-height: 79px;
  border-radius: 8px;
  object-fit: cover;
  /* This ensures the image covers the entire area */
}

.my-card {
  border-radius: 12px;
  overflow: hidden;
}

.videoIconContainer {
  display: flex;
  flex-direction: row;
  border-radius: 4px;
  align-items: center;
  padding-left: 15px;
  /**......... */
  height: 36px;
  width: 100%;
  cursor: pointer;
  background-color: #6fd73e;
}

.video_Icon {
  max-height: 20px;
  max-width: 17px;
  object-fit: contain;
}

.labelVideo {
  font-size: 16px;
  color: #ffffff;
  margin-left: 8px;
  margin-top: 2px;
}

.detail-child-img {
  width: 156px;
  height: 79px;
  object-fit: cover;
}

.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item {
  padding-left: 50px;
}

.v-list-item__icon {
  align-self: flex-start;
  margin: 10px 0;
}

.article-container {
  width: 35px !important;
  height: 35px !important;
}

.course-image {
  max-width: 156px;
  min-height: 79px;
  border-radius: 8px;
}

.article-image {
  max-width: 156px;
  min-height: 79px;
  max-height: 88px;
  border-radius: 8px;
}

.course-imagearticle {
  max-width: 156px;
  min-height: 79px;
  border-radius: 8px;
  width: 100%;
  height: auto;
}

.textWrappingStyle {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* F07 DSD — การ์ดแบบประเมินความพึงพอใจหลักสูตร */
.eval-card {
  border-radius: 16px !important;
  min-height: 110px;
  width: 100%;
  max-width: 1204px;
}
.eval-card--static {
  cursor: default;
}
</style>
